import { Button, Modal, Tabs, Upload, message, Image as AntdImage } from 'antd';
import Utils from '@utils/utils'
import { useEffect, useState, useMemo, useContext, useRef } from 'react';
import styles from './waterfall.module.scss'
import { useNavigate } from 'react-router-dom';
import {Masonry, MasonryItem,MasonryAbsoluteItem} from 'react-masonry-component2'
import API from '@api/api'
import eventBus from '@utils/eventBus';
import { AppContext } from '@utils/AppContext';
import { HOME_PAGE_TYPE, IMAGE_TYPE } from "@utils/CONST"

const FallsModal = (props) => {
    // const onUpload = (file) => {
    //     // console.log('props.itemData', props.itemData)
    //     const params  = props.itemData.params
    //     const imageType = props.itemData?.category
    //     const proName = file.name.substring(0, file.name.lastIndexOf('.'))
    //     const info = {file: file}
    //     if (imageType == IMAGE_TYPE.MODEL) {
    //         updateGlobalHomePageType(HOME_PAGE_TYPE.CLOTHING)
    //     } else if (imageType == IMAGE_TYPE.COMMODITY) {
    //         updateGlobalHomePageType(HOME_PAGE_TYPE.MERCHANDISE)
    //     }

    //     // console.log('imageType',  imageType)

    //     globalProInfoRef.current = {
    //         projectName: proName,
    //         imageType: imageType,
    //         inputImage: "",
    //         mask: {
    //             algoId: "",
    //             editedOutput: []
    //         },
    //         inpaint: {
    //             algoId: "",
    //             attr: {
    //                 person: params.person,
    //                 pose: "",
    //                 background: params.background,
    //                 version: ''
    //             }
    //         }
    //     }
    //     sessionStorage.setItem('taskCache', JSON.stringify({
    //         proInfo: {...globalProInfoRef.current},
    //         pageType: imageType,
    //         imgRatio: params?.imgRadio || '1:1',
    //         imgWidth: params?.imgWidth || 1024,
    //         imgHeight: params?.imgHeight || 1024,
    //         subBgId: params?.sub_bgid
    //     }))

    //     // console.log(' globalProInfoRef.current',   globalProInfoRef.current)

        
    //     if(imageType == IMAGE_TYPE.MODEL) {
    //         navigate(`/home/homemain/selfModelFake`, { replace: true, state: {
    //             info: info,
    //             type: IMAGE_TYPE.MODEL,
    //             modelFilter: {},
    //             clothCategory: '',
    //             gender: null,
    //             clothType: 1,
    //         }})
    //     } else if(imageType == IMAGE_TYPE.COMMODITY) {
    //         navigate(`/home/homemain/selfModelFake`, { replace: true, state: {
    //             info: info,
    //             type: IMAGE_TYPE.COMMODITY,
    //             modelFilter: [],
    //             clothCategory: '',
    //             gender: null,
    //             clothType: 1,
    //         }})
    //     } else if(imageType == IMAGE_TYPE.DRESSFORM) {
    //         navigate(`/home/homemain/selfModelFake`, { replace: true, state: {
    //             info: info,
    //             type: IMAGE_TYPE.DRESSFORM,
    //             modelFilter: {},
    //             clothCategory: '',
    //             gender: null,
    //             clothType: 1,
    //         }})
    //     }
    // }

    return (
        <div className={styles.FallsModal_box}>
            <div className={styles.FallsModal_img_box}>
                <AntdImage
                    width={"100%"}
                    height={props.itemHeight}
                    preview={false}
                    src={Utils.getImgUrlWithWebp(props.itemData?.oriImage, true)}
                />
                <AntdImage
                    width={"100%"}
                    height={props.itemHeight}
                    preview={false}
                    src={Utils.getImgUrlWithWebp(props.itemData?.inpaintImage, true)}
                />
                {/* <img style={{height: props.itemHeight}} src={props.itemData?.oriImage + '?x-oss-process=style/thumbnail-width-500'} alt="" />
                <img style={{height: props.itemHeight}} src={props.itemData?.inpaintImage + '?x-oss-process=style/thumbnail-width-500'}  alt="" /> */}
            </div>
        </div>
    )
}

const Waterfall = (props) => {
    const [caseList, setCaseList] = useState([])
    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState()
    const [activeKey, setActiveKey] = useState(0)
    const [showBtn, setShowBtn] = useState(true)
    const [itemHeight, setItemHeight] = useState(0)

    useEffect(() => {
        fetchData(20)
    }, [])

    const fetchData = (pageSize) => {
        API.showcaseList({
            pageIndex: 1,
            pageSize: pageSize,
            category: '',
        }).then((res) => {
            if(res.code == 0) {
                setCaseList(res.data.items)
            } else {
                message.error(res.message)
            }
        })
    }
    
    const contrastPicClick = (item) => {
        let heightVal = (400 * item.height) /  item.width
        setItemHeight(heightVal)
        console.log(heightVal)
        setSelected(item)
        setOpen(true)
    }

    const showMoreSample = () => {
        setShowBtn(false)
        fetchData(1000)
    }

    const showCases = useMemo(() => {
        if (activeKey == 2) {
           return caseList.filter(item => item.category == IMAGE_TYPE.COMMODITY)
        } else if (activeKey == 1) {
           return caseList.filter(item => item.category != IMAGE_TYPE.COMMODITY)
        } else {
           return caseList
        }
    }, [caseList, activeKey])

    useEffect(() => {
        for (let item of showCases) {
            const img = new Image()
            img.src = Utils.getImgUrlWithWebp(item.oriImage, true)
        }
    }, [showCases])

    return (
        <>
        <div className={styles.case_box}>
            <Tabs
                className={styles.case_type_tabs}
                defaultActiveKey="1"
                activeKey={activeKey}
                onChange={setActiveKey}
                centered
                items={[{
                    key: 0,
                    label: '全部',
                }, {
                    key: 1,
                    label: '服装图',
                }, {
                    key: 2,
                    label: '商品图',
                }]}
            />
            <div className={`${styles.case_item_box} ${showBtn && styles.showSample}`}>
                <div className={styles.CaseContainer}>
                    <Masonry
                        useAbsolute
                        sortWithHeight
                        columnsCountBreakPoints={{
                            1400: 5,
                            1000: 5,
                            700: 5,
                        }}
                    >
                    {
                        showCases.map((item) => (
                            <MasonryAbsoluteItem key={item.inpaintImage} width={item.width} height={item.height}>
                                <AntdImage
                                    className={styles.CaseCard}
                                    width={"100%"}
                                    preview={false}
                                    src={Utils.getImgUrlWithWebp(item.inpaintImage, true)}
                                    onClick={() => contrastPicClick(item)}
                                />
                            </MasonryAbsoluteItem>
                        ))
                    }
                    </Masonry>
                </div>
                {
                    showBtn?<p className={styles.showMoreSample}><span onClick={showMoreSample}>显示更多</span></p>: null
                }
            </div>
        </div>
        <Modal
            title={null}
            footer={null}
            centered
            destroyOnClose
            open={open}
            getContainer='#root'
            wrapClassName={styles.FallsModal}
            // classNames={{mask: styles.FallsModalMask, wrapper: styles.FallsModal}}
            onCancel={() => setOpen(false)}
        >
            <FallsModal itemData={selected} itemHeight={itemHeight} />
        </Modal>
        </>
    )
}

export default Waterfall